import React, { useContext, useState } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { useSettings } from '../../hooks/useSettings'
import {
  getPrimaryClass,
  getHoverClass,
  getBackgroundClass,
} from '../../utils/themeUtils'

import Consumption from './RechargingStationItems/Consumption/Consumption'
import Invoices from './RechargingStationItems/Invoices'
import PaymentHistory from './RechargingStationItems/PaymentHistory'
import Subscription from './RechargingStationItems/Subscription'

// `extraTabs` (optional): tabs the host adds after the standard ones, as
// [{ id, label, content }] with the label already translated. The portal adds
// "Info & costs" (ticket 6ad5d51d); LeaRes passes nothing. This file is shared
// with LeaRes (shared/MANIFEST.txt): host-specific content comes in by prop.
const PaymentModal = ({ setIsPaymentOpen, extraTabs = [] }) => {
  // Si apre su «Subscription» al ritorno da un acquisto di modulo o di piano e dal link
  // «abbonati» della pagina Costi del portale (?station=subscription).
  const [activeMenu, setActiveMenu] = useState(() => {
    const q = new URLSearchParams(window.location.search)
    return q.has('module_checkout') ||
      q.has('plan_checkout') ||
      q.get('station') === 'subscription'
      ? 'Subscription'
      : 'Consumption'
  })
  const { t } = useTranslation('payments')

  const tabs = [
    { id: 'Consumption', key: 'rechargingStation.tabs.consumption' },
    { id: 'Subscription', key: 'rechargingStation.tabs.subscription' },
    { id: 'History', key: 'rechargingStation.tabs.history' },
    { id: 'Invoices', key: 'rechargingStation.tabs.invoices' },
  ]

  const { isDarkMode, currentTheme } = useSettings()
  const extra = (extraTabs || []).filter(
    (tab) => tab && tab.id && tab.label && !tabs.some((base) => base.id === tab.id)
  )
  const activeExtra = extra.find((tab) => tab.id === activeMenu)

  return (
    // Container a tutta area (stile dashboard) invece di un modal flottante.
    <div
      className={clsx(
        // z sopra chatbot (z-[9999]) e ogni widget flottante: solo la station visibile
        'fixed inset-0 z-[10000] flex flex-col',
        getBackgroundClass(currentTheme)
      )}
    >
      <div
        className={clsx(
          'flex items-center justify-between py-2 px-5 leading-tight text-white text-base cursor-default shadow-[4px_4px_10px_0px_#00000040] flex-shrink-0',
          getPrimaryClass(currentTheme)
        )}
      >
        <span>{t('rechargingStation.title')}</span>
        <button
          className="text-lg px-2 py-1 rounded hover:bg-white hover:bg-opacity-10"
          onClick={() => setIsPaymentOpen(false)}
          aria-label="close"
        >
          ✕
        </button>
      </div>
      {/* Contenuto centrato in una colonna a larghezza massima: evita lo
          sparpagliamento su schermi larghi e stacca i widget dai margini. */}
      <div className="flex-1 overflow-hidden flex justify-center px-6 py-8 desktop:px-10 desktop:py-10">
        <div className="w-full max-w-[1100px] h-full flex gap-8">
          {activeMenu !== 'Payment' && (
            <div className="w-[200px] flex-shrink-0">
              <ul className="flex flex-col gap-3">
                {[...tabs, ...extra].map((tab) => (
                  <li className="list-none" key={tab.id}>
                    <button
                      className={clsx(
                        'h-[40px] w-full text-white rounded-xl transition duration-100 active:shadow-[inset_0px_0px_14px_5px_#00000020] flex justify-center items-center',
                        getPrimaryClass(currentTheme),
                        {
                          [getHoverClass(currentTheme)]: activeMenu !== tab.id,
                          'brightness-125 cursor-default pointer-events-none':
                            activeMenu === tab.id,
                        }
                      )}
                      onClick={() => setActiveMenu(tab.id)}
                    >
                      {tab.key ? t(tab.key) : tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className="flex-1 min-w-0 overflow-auto">
            {activeMenu === 'Consumption' || activeMenu === 'Payment' ? (
              <Consumption
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
              />
            ) : (
              ''
            )}
            {activeMenu === 'Subscription' && <Subscription />}
            {activeMenu === 'History' && <PaymentHistory />}
            {activeMenu === 'Invoices' && <Invoices />}
            {activeExtra && activeExtra.content}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentModal
